export default __webpack_public_path__ + "static/media/team-cat-03.29329950.png";